export const LANGUAGES = [
  {
    text: 'English',
    key: 'en',
  },
  {
    text: '日本語',
    key: 'ja',
  },
];

export const CDN_ROOT = process.env.REACT_APP_CDN_ROOT;
export const PREVIEW_HOST = process.env.REACT_APP_PREVIEW_HOST;

export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

export const ROLE_TEXTS = {
  view: 'viewer',
  edit: 'editor',
  manage: 'manager',
  admin: 'admin',
};

export const DEFAULT_DEVELOPERS_PRODUCT = '968c2f40-770c-411e-8dc1-633b0bcbd203';
